import { ensureAuthenticated } from '../auth/authenticate';
import config from '../config/config';
import log from '../utils/logger';
import { getStage } from '../utils/environment';

/**
 * API client for Liquidity Engine APIs.
 * Sends the existing Cognito JWT in the Authorization header.
 */
const LiquidityEngineAPIClient = {

    getBaseUrl: function () {
        return config.liquidityEngineAPI[getStage()];
    },

    invoke: async function (method, path, queryParams = {}, body = null) {
        const auth = await ensureAuthenticated();
        const jwtToken = auth.getSignInUserSession().getIdToken().getJwtToken();

        let url = this.getBaseUrl() + path;

        const params = new URLSearchParams(queryParams).toString();
        if (params) {
            url += '?' + params;
        }

        const opts = {
            method: method,
            headers: {
                'Authorization': jwtToken,
            },
        };

        if (body && (method === 'POST' || method === 'PUT' || method === 'PATCH')) {
            opts.headers['Content-Type'] = 'application/json';
            opts.body = JSON.stringify(body);
        }

        log.logInfo('LiquidityEngine API call: ' + method + ' ' + url);

        const response = await fetch(url, opts);

        if (!response.ok) {
            const errorText = await response.text();
            log.logError('LiquidityEngine API error: ' + response.status + ' ' + errorText);
            throw new Error('API call failed: ' + response.status);
        }

        return response.json();
    },
};

export default LiquidityEngineAPIClient;
